(function () {
  'use strict';

  const STORAGE_KEY = 'amaroso-size-guide-unit';

  const getStoredUnit = (fallback) => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored === 'in' || stored === 'cm' ? stored : fallback;
    } catch (error) {
      return fallback;
    }
  };

  const saveUnit = (unit) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, unit);
    } catch (error) {
      // The guide still works when browser storage is unavailable.
    }
  };

  const setUnit = (root, unit) => {
    if (!root || (unit !== 'cm' && unit !== 'in')) return;

    root.querySelectorAll('[data-cm]').forEach((cell) => {
      const centimetres = Number(cell.dataset.cm);
      cell.textContent = unit === 'cm'
        ? String(centimetres)
        : (centimetres / 2.54).toFixed(1).replace(/\.0$/, '');
    });

    root.querySelectorAll('[data-size-guide-unit-label]').forEach((label) => {
      label.textContent = unit === 'cm' ? '(cm)' : '(in)';
    });

    root.querySelectorAll('[data-size-guide-unit]').forEach((button) => {
      const active = button.dataset.sizeGuideUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.dataset.activeUnit = unit;
  };

  const initialiseGuides = (scope) => {
    (scope || document).querySelectorAll('[data-amaroso-size-guide]').forEach((root) => {
      if (root.dataset.sizeGuideReady === 'true') return;
      root.dataset.sizeGuideReady = 'true';
      setUnit(root, getStoredUnit(root.dataset.defaultUnit || 'cm'));
    });
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-guide-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.sizeGuideOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        initialiseGuides(dialog);
        dialog.showModal();
        document.body.classList.add('amaroso-size-guide-open');
      }
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-amaroso-size-guide-dialog]');
      if (dialog) dialog.close();
      return;
    }

    const unitButton = event.target.closest('[data-size-guide-unit]');
    if (unitButton) {
      const root = unitButton.closest('[data-amaroso-size-guide]');
      const unit = unitButton.dataset.sizeGuideUnit;
      saveUnit(unit);
      document.querySelectorAll('[data-amaroso-size-guide]').forEach((guide) => setUnit(guide, unit));
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-amaroso-size-guide-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches && event.target.matches('[data-amaroso-size-guide-dialog]')) {
      document.body.classList.remove('amaroso-size-guide-open');
    }
  }, true);

  document.addEventListener('shopify:section:load', (event) => initialiseGuides(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseGuides(document), { once: true });
  } else {
    initialiseGuides(document);
  }
})();
